import { productListTemplateSlots } from '@boels/models';

interface LayoutConfig {
  [templateName: string]: LayoutTemplate;
}

export interface LayoutTemplate {
  pageFold?: string;
  slots: string[];
  topSlots?: string[];
  bottomSlots?: string[];
  headerMiddle?: {
    slots: string[];
  };
}

export const layoutConfig: LayoutConfig = {
  TemplateFullWidth: {
    pageFold: 'Section2',
    slots: [
      'Section1',
      'Section2',
      'Section3',
      'Section4',
      'Section5',
      'Section6',
      'Section7',
      'Section8',
      'Section9',
      'Section10',
    ],
  },
  HomepageTemplate: {
    pageFold: 'Section1',
    topSlots: ['TopHeaderSlot', 'BottomHeaderSlot'],
    slots: [
      'Section1',
      'Section2',
      'Section3',
      'Section4',
      'Section5',
      'Section6',
      'Section7',
    ],
  },
  LandingPage2Template: {
    pageFold: 'Section2B',
    slots: [
      'Section1',
      'Section2A',
      'Section2B',
      'Section2C',
      'Section3',
      'Section4',
      'Section5',
    ],
  },
  TemplateSideBar: {
    pageFold: 'Section2A',
    topSlots: ['Section1'],
    slots: ['Section2A', 'Section2B'],
    bottomSlots: ['Section2', 'Section3', 'Section4'],
  },
  ProductListPageTemplate: {
    slots: [
      productListTemplateSlots['PLPLeftRefinements'],
      productListTemplateSlots['ProductListSlot'],
    ],
  },
  MinimalPageTemplate: {
    headerMiddle: {
      slots: ['SiteLogo'],
    },
    slots: ['Section1'],
  },
  ProductDetailsPageTemplate: {
    pageFold: 'Summary',
    slots: [
      'Summary',
      'UpSelling',
      'CrossSelling',
      'Tabs',
      'PlaceholderContentSlot',
    ],
  },
  CartPageTemplate: {
    pageFold: 'TopContent',
    slots: ['TopContent', 'EmptyCartMiddleContent', 'BottomContentSlot'],
  },
  MultiStepCheckoutSummaryPageTemplate: {
    pageFold: 'BodyContent',
    slots: ['TopContent', 'BodyContent', 'SideContent', 'BottomContent'],
  },
  OrderConfirmationPageTemplate: {
    slots: ['BodyContent', 'SideContent'],
  },
  CheckoutAccountPageTemplate: {
    pageFold: 'LeftContentSlot',
    slots: ['LeftContentSlot'],
  },
  CategoryPageTemplate: {
    pageFold: 'Section2',
    slots: ['Section1', 'Section2', 'Section3'],
  },
  SearchResultsListPageTemplate: {
    pageFold: 'ProductLeftRefinements',
    slots: ['ProductLeftRefinements', 'SearchResultsListSlot'],
  },
  StoreFinderPageTemplate: {
    pageFold: 'MiddleContent',
    slots: ['MiddleContent'],
  },
  ErrorPageTemplate: {
    pageFold: 'TopContent',
    slots: ['TopContent', 'MiddleContent', 'BottomContent'],
  },
};
